import { Lock, CheckCircleOutlined, CheckCircle } from "./svg";

type IconName = "lock" | "checkCircleOutlined" | "checkCircle";

const Icon = (props: {
  name: IconName;
  style?: React.CSSProperties;
  onClick?: () => void;
}) => {
  const { style, name } = props;
  const comp = {
    lock: Lock,
    checkCircleOutlined: CheckCircleOutlined,
    checkCircle: CheckCircle,
  };
  const Comp = comp[name];
  return (
    <span className="anticon" style={style} onClick={props.onClick}>
      <Comp />
    </span>
  );
};

export default Icon;
